import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column gap-2 my-2" }



  // Components
  import BaseTotal from './BaseTotal.vue'

  // Translations
  import { useI18n } from 'vue-i18n'
  interface Props {
    totalPrice: number
    leftToPay?: number
    depositToPay?: number | null
    totalPaid?: number
    isQuoteOrCartInProgress: boolean
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Totals',
  props: {
    totalPrice: {},
    leftToPay: {},
    depositToPay: {},
    totalPaid: {},
    isQuoteOrCartInProgress: { type: Boolean }
  },
  setup(__props: any) {

  // Vue
  const { t } = useI18n()

  // Props
  const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BaseTotal, {
      id: "total-price",
      price: props.totalPrice,
      title: _unref(t)('payments.totalPrice')
    }, null, 8, ["price", "title"]),
    (props.totalPaid && props.totalPaid !== props.totalPrice)
      ? (_openBlock(), _createBlock(BaseTotal, {
          key: 0,
          id: "total-paid",
          price: props.totalPaid,
          title: _unref(t)('payments.totalPaid')
        }, null, 8, ["price", "title"]))
      : _createCommentVNode("", true),
    (props.depositToPay && props.depositToPay > 0)
      ? (_openBlock(), _createBlock(BaseTotal, {
          key: 1,
          id: "deposit-to-pay",
          price: props.depositToPay,
          title: _unref(t)('payments.depositToPay')
        }, null, 8, ["price", "title"]))
      : _createCommentVNode("", true),
    (props.leftToPay)
      ? (_openBlock(), _createBlock(BaseTotal, {
          key: 2,
          id: "balance",
          price: props.leftToPay,
          title: _unref(t)('payments.leftToPay'),
          "text-class": 'body-strong text-grey-900'
        }, null, 8, ["price", "title"]))
      : _createCommentVNode("", true)
  ]))
}
}

})